import CommonTNTControlBase from '../../../util/CommonTNTControlBase'

class MessageBaseController extends CommonTNTControlBase {
  /*@ngInject*/
  constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    super(Auth, $state, User, Service, Modal, $translate, $stateParams)


    this.errors = {}
    this.model = {}
    this.loading = false
    this.errorMessage = ''
    this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: this.$translate.instant('common.yes'),
        off: this.$translate.instant('common.no')
      },
      onColor: 'success',
      offColor: 'danger'
    }

  }

  askCreate() {

    this.Modal.confirm({
      header: this.$translate.instant('message.create_another_title'),
      message: this.$translate.instant('message.create_another_message'),
      callback: ({
        modal,
        $scope
      }) => {
        this.reset()
        modal.close()
      },
      negative: ({
        modal,
        $scope
      }) => {
        modal.close()
        window.history.go(-1)
      },
      type: 'primary',
      buttons: [this.$translate.instant('common.yes'), this.$translate.instant('common.no')]
    })
  }

  validate() {
    this.clearErrors()

    for (let key in this.model) {
      if (!this.model[key]) {
        this.addError(key, key + ' is mandatory')
      }
    }

    return Object.keys(this.errors).length <= 0
  }

  clearErrors() {
    this.errors = {}
    this.errorMessage = ''
  }

  addError(id, message) {
    this.errors[id] = message
  }
}

export default MessageBaseController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/common/message.base.controller.js